// @ts-nocheck
/* eslint-disable */
export const llaPlatformStarIcon = {
    data: `<svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.00065 0.958332L8.45898 5.54167H13.0423L9.29232 8.45833L10.5423 13.0417L7.00065 10.125L3.45898 13.0417L4.70898 8.45833L0.958984 5.54167H5.54232L7.00065 0.958332Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'star' as const
};